export interface PhotoSizeOptions {
  maxWidth?: number;
  maxHeight?: number;
}

const DEFAULT_PHOTO_OPTIONS: Required<PhotoSizeOptions> = {
  maxWidth: 4800,
  maxHeight: 4800,
};

export function getGooglePhotoUrl(
  photo: unknown,
  options?: PhotoSizeOptions
): string | null {
  if (!photo) {
    return null;
  }

  const mergedOptions = { ...DEFAULT_PHOTO_OPTIONS, ...options };
  const candidate = photo as {
    getUrl?: (opts: PhotoSizeOptions) => string;
    getURI?: (opts: PhotoSizeOptions) => string;
    createObjectURL?: () => string;
    url?: string;
    uri?: string;
  };

  if (typeof candidate.getUrl === "function") {
    return candidate.getUrl(mergedOptions);
  }

  if (typeof candidate.getURI === "function") {
    return candidate.getURI(mergedOptions);
  }

  if (typeof candidate.createObjectURL === "function") {
    return candidate.createObjectURL();
  }

  if (typeof candidate.url === "string") {
    return candidate.url;
  }

  if (typeof candidate.uri === "string") {
    return candidate.uri;
  }

  return null;
}
